import React from 'react';
import Team1 from '../../assets/team/Bolanle.png';
import Team2 from '../../assets/team/ayo.png';
import Team3 from '../../assets/team/babara.png';
import Team4 from '../../assets/team/micheal.png';
import Team5 from '../../assets/team/ayoo.png';

const Team = ({ id }) => {
  const Teams = [
    {
      background: 'bg-[#FAFAFA]',
      name: 'Bolanle Caroline Olaseinde',
      profile: Team1,
      bio1: <p>Bolanle, as the Administrator of Ireti- Ola children’s Foundation ensures that every child is treated with love and care and is given the best educational opportunities to become successful someday.
        <br></br> <br></br>
       She has a university degree in Microbiology and a post graduate degree in Food Science and Technology. She has a Diploma in caregiving and is certified in First Aid and Basic Life Support, Safeguarding of Children (Child Protection) Level 2 (VTQ), Communication in care Level 1 and CPR/ Basic Life Support for health care professionals Level 2 (VTQ). She is a compassionate and motivated woman with many years of hands-on experience in the care of children.
        <br></br><br></br>
        She supervises the care of the wards in the home, researches and develops community initiative programs, organise events, deliver communication campaigns and take care of the educational planning and social aspects of Ireti- Ola Children’s Foundation.</p>,
      
    },
    {
      background: 'bg-[#EBF2EC]',
      name: 'Ayo Olaseinde',
      profile: Team2,
      bio1: <p>“It has always been my wish to help less privileged children and young vulnerable adults by giving them a much better perspective and narrative”.
      <br></br><br></br>
       Ayo studied economics and statistics and he has more than 19 years of experience in marketing, market research, and social and health research.
       <br></br><br></br>
        Ayo works to ensure that the emotional needs of the children are taken into account and that they are adequately intellectually challenged. He coordinates activities that involves the community which includes crises management, gathering and management of information, fostering and building of good relationships with the host community.
        <br></br><br></br>
         He is a member of the board of trustees of Ireti-Ola children’s foundation.</p>,
     
    },
    {
      background: 'bg-[#EBF2EC]',
      name: 'Barbara Peters',
      profile: Team3,
      bio1: <p>As managing director of an international market research company, Barbara visited Nigeria for the first time in 2013. During her education studies, she worked with several children’s aid organizations. She developed interest in social work and wanted to be part of an organization that can help children effectively.
        <br></br> <br></br>
       This became a reality in 2017 with the establishment of Ireti- Ola children’s foundation. Barbara brings with her over 20 years of experience in market research and 10 years of experience in social work and is particularly interested in education and social problems in emerging countries. She is a member of the board trustees and takes care of the contact and communications with other aid organizations.</p>,
      
    },
    {
      background: 'bg-[#FAFAFA]',
      name: 'Michael Layhausen',
      profile: Team4,
      bio1: <p>“For me it is especially important to help people locally – where it matters”.
      <br></br><br></br>
       Michael travelled to Nigeria for the first time in 2012 for work and since then has pursued the goal of setting up a social project there. By co-founding GENICO, a major sponsor of Ireti-Ola children’s foundation, this goal has finally become a reality.
       <br></br><br></br>
        A graduate of mechanical engineering, Michael headed a market research company for 25 years and also brings expertise from the construction industry. His focus is therefore particularly on economic cooperation with developing countries and the local people. In addition to his role as a member of the board of trustee of Ireti-Ola children’s foundation, Mike also manages the construction planning aspect of the home.</p>,
      
    },
  ];

  return (
    <section className="w-full bg-[#EFF3FB] mt-8 p-5 pb-14" id={id}>
      <h1 className="section-header">Our Team</h1>
      <section className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 px-5 mt-8" id={id}>
        {Teams.map((team, index) => (
          <div
            className={`${team.background} rounded-lg grid place-items-center p-8 gap-3`}
            key={index}
          >
            {/* <img
              src={team.profile}
              alt={`${team.name}'s profile`}
             
              className=" mb-4 object-cover rounded-full lg:rounded-none shadow-md"
            /> */}
            <h1 className="text-[#102343] text-[28px] my-3 font-[600] text-center">
              {team.name}
            </h1>
            <p className="text-center">{team.bio1}</p>
            <p className="text-center mt-2">{team.bio2}</p>
          </div>
        ))}
      </section>
      <div className='  mx-auto sm:w-[50%] mt-6 gap-6 '>
      <div
            className={` bg-[#FFFFFF] rounded-lg grid place-items-center p-8 gap-3`}
            
          >
            {/* <img
              src={Team5}
              alt={` profile`}
             
              className=" mb-4 object-cover rounded-full lg:rounded-none shadow-md"
            /> */}
            <h1 className="text-[#102343] text-[28px] my-3 font-[600] text-center">
          Oladele Omolara
            </h1>
            <p className="text-center">At Iretiola children's foundation, she is responsible for the standard of education available to the children, the quality of staff, welfare, security and safety of pupils and teachers; and coordination of teaching and learning programmes as recommended by educational laws, authorities and agencies that are involved with the welfare of orphans and the vulnerable in the society.
            <br></br><br></br>
             Mrs Omolara Oladele is a Chemistry graduate from the University of Ibadan. After her National Youth Service at the NNPC, Port Harcourt in 1985, she proceeded to Vienna, Austria to work with Merkur Gummiwerk.
             <br></br><br></br>
              In 1990, she was engaged by the Oyo State Teaching Service Commission where she rose to the position of Head of Department (Sciences). In 2001, she was employed as the Principal of ESC Model College (now Lead City High School) Ibadan. She was responsible for Budget and Strategic Planning and Implementation; Developing Curriculum and setting academic goals; motivating and evaluating the workforce, addressing parents and teachers concerns, overseeing conflict resolution and disciplinary matters among other duties. She is a seasoned school administrator with excellent results in academic programmes and students achievements.</p>
           
          </div>
      </div>
    </section>
  );
};

export default Team;